export default "__VITE_ASSET__Crgs8nxI__"